import { render, staticRenderFns } from "./software-1.vue?vue&type=template&id=636244a6&"
import script from "./software-1.vue?vue&type=script&lang=js&"
export * from "./software-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports